import './HomeApp.scss';
import React, { useEffect, useState } from "react";
import * as S from '../scss/theme';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import MainPage from './MainPage';
import Board from '../page_board/Board';
import { setIsAdmin } from '../reduxToolkit/reduxBoard';
import {setIsSelectedTab_home} from '../reduxToolkit/reduxPayment';

import { useDispatch, useSelector } from 'react-redux';

const HomeApp = () => {

    const dispatch = useDispatch();
    const isSelectedTab_home = useSelector(state => state.reduxPayment.isSelectedTab_home) ?? 0; // Redux에서 탭 상태 가져오기

    useEffect(() => {
        dispatch(setIsAdmin(false));

    }, []);


    const handleTabSelect = (index) => {
        dispatch(setIsSelectedTab_home(index));
    };

    //=========================================
    return(
        <S.Section_full>
        <div className="HomeApp">
        <section className="sec-homeApp">
            <Tabs selectedIndex={isSelectedTab_home} onSelect={handleTabSelect}>
                <TabList className='tabList1'>
                    <Tab>HOME</Tab>
                    <Tab>공지사항</Tab>
                </TabList>

                <TabPanel> <MainPage /> </TabPanel>
                <TabPanel> <Board /> </TabPanel>

                
            </Tabs>
        </section>

 
        </div>
        </S.Section_full>
    );
}

export default HomeApp;